const baseText = 'Ad'
const mainHeaderConfig = {
  baseText,
  selectedLabel: `${baseText}s Selected`,
  normSelectedLabel: `Norm ${baseText}s Selected`
}

export default mainHeaderConfig
